import React from 'react'

import ReturnButton from '../../UI/Buttons/ReturnButton'


const DetailHeader = props => {

    return (
        <div className="columns">
            <div className="column">
                <h2 className='is-size-4'>{props.title}</h2>
            </div>
            <div className="column is-2 is-pulled-right has-text-right">
                <ReturnButton />
            </div>
        </div>
    )
}

export default DetailHeader


// WEBPACK FOOTER //
// ./src/acervo/components/Sections/Detail/DetailHeader.js